module.exports = __webpack_public_path__ + "static/media/first-prize.fe3ef182.png";